/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StaffParticipant } from './StaffParticipant';
import {
    StaffParticipantFromJSON,
    StaffParticipantFromJSONTyped,
    StaffParticipantToJSON,
    StaffParticipantToJSONTyped,
} from './StaffParticipant';

/**
 * 
 * @export
 * @interface StaffParticipantResponse
 */
export interface StaffParticipantResponse {
    /**
     * 
     */
    data: StaffParticipant;
}

/**
 * Check if a given object implements the StaffParticipantResponse interface.
 */
export function instanceOfStaffParticipantResponse(value: object): value is StaffParticipantResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function StaffParticipantResponseFromJSON(json: any): StaffParticipantResponse {
    return StaffParticipantResponseFromJSONTyped(json, false);
}

export function StaffParticipantResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffParticipantResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': StaffParticipantFromJSON(json['data']),
    };
}

export function StaffParticipantResponseToJSON(json: any): StaffParticipantResponse {
    return StaffParticipantResponseToJSONTyped(json, false);
}

export function StaffParticipantResponseToJSONTyped(value?: StaffParticipantResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': StaffParticipantToJSON(value['data']),
    };
}

